import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { getMockupGenerators } from "actions/mockupAction";
import { ReactTable } from "components/Table";
import { ListDateType } from "helper/constant";
import ReactImageMagnify from 'react-image-magnify';
import {
    formatterCreateAt,
    convertTZ,
    FormatterStatus,
} from "components/Function";
import Loading from "components/Loading";
import SelectBox from "components/elements/selectBox";

const MockupList = ({
    getMockupGenerators,
    mockup,
    formatterCreateAt,
    FormatterStatus,
}) => {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [dateType, setDateType] = useState("");
    const [mockups_selected, setMockupSelected] = useState([]);
    const [filter, setFilter] = useState({});

    const { t } = useTranslation();

    const { listgenerator, listgeneratorSize, isLoading } = mockup;

    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "20",
            value: 20,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "All",
            value: listgeneratorSize || 50,
        },
    ];

    useEffect(() => {
        if (Object.keys(filter).length) {
            getMockupGenerators({ page, sizeperpage: sizePerPage, search: searchText, filter });
        }
    }, [getMockupGenerators, page, sizePerPage, searchText, filter]);


    useEffect(() => {
        setTotalSize(listgeneratorSize);
    }, [listgeneratorSize]);

    useEffect(() => {
        setPage(1);
        setSizePerPage(50);

        if (dateType === "") {
            setFilter((prev) => ({
                ...prev,
                dateStart: "",
                dateEnd: "",
            }));
        }
        if (dateType === "custom") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "today") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "yesterday") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate());
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 7 - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_month") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_month") {
            let date = new Date();
            date = convertTZ(date);
            date.setMonth(date.getMonth() - 1);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_year") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_year") {
            let date = new Date();
            date = convertTZ(date);
            date.setFullYear(date.getFullYear() - 1);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        // eslint-disable-next-line
    }, [dateType]);

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            editable: false,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "title",
            text: t("Title"),
            sort: true,
            editable: false,
            formatter: (cell, row) => row?.designs?.title,
        },
        {
            dataField: "preview_mockup",
            text: t("Mockup"),
            sort: true,
            editable: false,
            formatter: (cell, row) => (
                <>{row?.mockups?.filter((v) => v?.preview_mockup).map((item, index) => {
                    return (
                        <div key={index} className="symbol symbol-50px ms-2 mb-2" style={{ border: "1px solid #cecece" }}>
                            <Link to={item.preview_mockup} target="_blank"><ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: item.preview_mockup || require("components/assets/media/misc/image.png") }, largeImage: { src: item.preview_mockup || require("components/assets/media/misc/image.png"), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '300%', height: '300%' }, enlargedImageContainerStyle: { "zIndex": 99 }, className: "cursor-pointer", enlargedImageContainerClassName: "al-zoom-img-cus" }} /></Link>
                        </div>
                    );
                })}
                </>
            ),
        },
        {
            dataField: "design",
            text: t("Design"),
            sort: true,
            editable: false,
            formatter: (cell, row) => (
                <>{Object.values(row?.designs?.design)?.filter((v) => v !== "").map((item, index) => {
                    return (
                        <div key={index} className="symbol symbol-50px ms-2 mb-2" style={{ border: "1px solid #cecece" }}>
                            <Link to={item} target="_blank"><ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: item || require("components/assets/media/misc/image.png") }, largeImage: { src: item || require("components/assets/media/misc/image.png"), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '300%', height: '300%' }, enlargedImageContainerStyle: { "zIndex": 99 }, className: "cursor-pointer", enlargedImageContainerClassName: "al-zoom-img-cus" }} /></Link>
                        </div>
                    );
                })}
                </>
            ),
        },
        {
            dataField: "status",
            text: t("Status"),
            sort: true,
            editable: false,
            formatter: (cell, row) => <>{cell === "COMPLETED" ? (<><FormatterStatus status={cell} /> - <Link to={row?.downloadUrl} className="btn btn-sm btn-primary">{t("Download")}</Link></>) : <FormatterStatus status={cell} />}</>
        },
        {
            dataField: "created_at",
            text: t("Created At"),
            sort: true,
            editable: false,
            formatter: (cell, row) => formatterCreateAt(cell),
        },
    ];

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setSearchText(searchText);
        } else {
            setPage(page);
            setSizePerPage(sizePerPage);
        }
    };

    const handleEventDate = (start, end) => {
        setPage(1);
        setSizePerPage(50);

        let date_start = new Date(start);
        date_start.setHours(0, 0, 0, 0);

        let date_end = new Date(end);
        date_end.setHours(23, 59, 59, 999);
        setFilter((prev) => ({
            ...prev,
            dateStart: date_start.getTime(),
            dateEnd: date_end.getTime(),
        }));
    };

    const removeSelect = (arr, value) => {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    };

    const onSelect = (row, isSelect) => {
        var mockups_selected_tmp = mockups_selected;
        if (isSelect) {
            mockups_selected_tmp.push(row._id);
        } else {
            mockups_selected_tmp = removeSelect(mockups_selected_tmp, row._id);
        }
        var new_arr = JSON.stringify(mockups_selected_tmp);
        setMockupSelected(JSON.parse(new_arr));
        if (mockups_selected_tmp.length !== 0) {
            // setLoadingSync(false);
        }
        if (mockups_selected_tmp.length === 0) {
            // setLoadingSync(true);
        }
    };

    const onSelectAll = (isSelect, row) => {
        var mockups_selected_tmp = mockups_selected;
        if (isSelect) {
            mockups_selected_tmp = row.map((v, i) => v._id);
        } else {
            mockups_selected_tmp = [];
        }
        setMockupSelected(mockups_selected_tmp);
        if (mockups_selected_tmp.length !== 0) {
            // setLoadingSync(false);
        }
        if (mockups_selected_tmp.length === 0) {
            // setLoadingSync(true);
        }
    };

    const selectRow = {
        mode: "checkbox",
        clickToSelect: false,
        selected: mockups_selected,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
            <div className="d-flex">
                <input
                    type="checkbox"
                    ref={(input) => {
                        if (input) {
                            input.indeterminate = indeterminate;
                            input.checked = checked;
                        }
                    }}
                    onChange={onChange}
                />
                <span style={{ marginLeft: '8px' }}>({mockups_selected.length})</span>
            </div>
        ),
    };

    const groupButton = () => {
        return (
            <>
                <div className="mb-5 d-flex flex-md-row flex-column gap-2">
                    <SelectBox
                        options={[{ value: "COMPLETED", label: t("COMPLETED") }, { value: "PENDING", label: t("PENDING") }, { value: "FAILED", label: t("FAILED") }]}
                        name="status"
                        placeholder="Select a status ... "
                        value={filter.status || ""}
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                status: data.value || "",
                            }));
                            setPage(1);
                        }}
                    />
                    <Select
                        name="dateType"
                        options={ListDateType}
                        className="al-select"
                        classNamePrefix="select"
                        value={ListDateType.filter(({ value }) => value === dateType)}
                        onChange={(e) => {
                            setDateType(e?.value || "");
                        }}
                        placeholder="Select a date ... "
                    />
                    {dateType === "custom" && filter?.dateStart && filter?.dateEnd ? (
                        <DateRangePicker
                            onCallback={handleEventDate}
                            initialSettings={{
                                startDate: formatterCreateAt(filter.dateStart, "dmy"),
                                endDate: formatterCreateAt(filter.dateEnd, "dmy"),
                                showDropdowns: true,
                                locale: { format: "DD/MM/YYYY" },
                            }}
                        >
                            <input type="text" className="form-control al-form-control-daterangepicker mr-1" />
                        </DateRangePicker>
                    ) : (
                        ""
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <div className="card min-w-full">
                <Loading isLoading={isLoading} />
                <div className="card-body">
                    <div className="al-variants-table al-max-height-table-cus">
                        <ReactTable
                            columns={columns}
                            data={listgenerator || []}
                            groupButton={groupButton}
                            handleTableChange={handleTableChange}
                            page={page}
                            sizePerPage={sizePerPage}
                            totalSize={totalSize}
                            alClassName="table-layout-inherit al-d-none-option-react-select"
                            sizePerPageList={sizePerPageList}
                            isSelectRow={true}
                            selectRow={selectRow}
                            isCellEdit={true}
                        />
                    </div>
                </div>
            </div>
        </>

    );
};

const mapStateToProps = ({ mockup }) => ({ mockup });
const mapDispatchToProps = {
    formatterCreateAt,
    getMockupGenerators,
    FormatterStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(MockupList);